import type {InjectionKey} from 'vue';
import type {MissionPreferencesRepository} from '~/types/domain/repository/MissionPreferencesRepository';
import type {PortfolioRepository} from '~/types/domain/repository/PortfolioRepository';
import type {ProfileAdminRepository} from '~/types/domain/repository/ProfileAdminRepository';
import type {ProfileRepository} from '~/types/domain/repository/ProfileRepository';
import type {RecommendationRepository} from '~/types/domain/repository/RecommendationRepository';
import {missionPreferencesRepository} from '~/types/infra/repository/MissionPreferencesAPI';
import {portfolioRepository} from '~/types/infra/repository/PortfolioRepositoryAPI';
import {profileAdminRepository} from '~/types/infra/repository/ProfileAdminRepositoryAPI';
import {profileRepository} from '~/types/infra/repository/ProfileRepositoryAPI';
import {recommendationRepository} from '~/types/infra/repository/RecommendationRepositoryAPI';

const repositoriesInjectionKeys = {
    missionPreferences: Symbol('missionPreferences') as InjectionKey<MissionPreferencesRepository>,
    portfolio: Symbol('portfolio') as InjectionKey<PortfolioRepository>,
    profile: Symbol('profile') as InjectionKey<ProfileRepository>,
    profileAdmin: Symbol('profileAdmin') as InjectionKey<ProfileAdminRepository>,
    recommendation: Symbol('recommendation') as InjectionKey<RecommendationRepository>,
};

function getRepositories(): Record<symbol, any> {
    return {
        [repositoriesInjectionKeys.missionPreferences as symbol]: missionPreferencesRepository,
        [repositoriesInjectionKeys.portfolio as symbol]: portfolioRepository,
        [repositoriesInjectionKeys.profile as symbol]: profileRepository,
        [repositoriesInjectionKeys.profileAdmin as symbol]: profileAdminRepository,
        [repositoriesInjectionKeys.recommendation as symbol]: recommendationRepository,
    };
}

export const RegisteredRepositories = {
    all: () => getRepositories(),
    injectionKeys: repositoriesInjectionKeys,
};
